import yup from '../yup';

const vaccineSchema = yup.object().shape({
  renew_insurance: yup.bool().required().default(true),
});

export default vaccineSchema;
